import { render, staticRenderFns } from "./user_bind.vue?vue&type=template&id=44215786&scoped=true&"
import script from "./user_bind.vue?vue&type=script&lang=js&"
export * from "./user_bind.vue?vue&type=script&lang=js&"
import style0 from "./user_bind.vue?vue&type=style&index=0&id=44215786&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44215786",
  null
  
)

export default component.exports